// src/utils/constants.js

export const VOTE_DURATION   = 120; // seconds per phase
export const DOCTOR_SKIP_DELAY = 10; // seconds to wait before auto-skipping empty doctor phase
export const MAX_PLAYERS     = 10;
export const MIN_PLAYERS     = 5;

export const PHASES = {
  LOBBY:   "lobby",
  REVEAL:  "reveal",
  NIGHT:   "night",
  SAVE:    "save",
  DAY:     "day",
  RESULT:  "result",
  ENDED:   "ended",
};

export const ROLES = {
  MAFIA:   "mafia",
  DOCTOR:  "doctor",
  CITIZEN: "citizen",
};

/** Fresh room state written to Firebase when a room is created or reset */
export function freshRoomState(players = [], lobbyMafia = 1, lobbyDoctor = 1) {
  return {
    players,
    phase:            PHASES.LOBBY,
    round:            1,
    mafiaVotes:       {},
    doctorVotes:      {},
    dayVotes:         {},
    confirmedVotes:   [],
    skippedVotes:     [],     // players who pressed "Skip"
    nightKilled:      null,
    savedId:          null,
    lastAnnouncement: null,
    announcementId:   null,
    dayAnnouncement:  null,
    dayAnnouncementId:null,
    winner:           null,
    revealReady:      [],
    timerEndsAt:      null,
    timerDuration:    VOTE_DURATION,
    lobbyMafia,
    lobbyDoctor,
    // used to signal all-doctors-dead fast-skip
    doctorSkipAt:     null,
  };
}

/** Fresh player object */
export function freshPlayer(id, name, isHost = false) {
  return { id, name, role: null, alive: true, roleRevealed: false, isHost };
}
